import {
  GET_APPOINTMENT,
  GET_APPOINTMENT_SUCCESS,
  GET_APPOINTMENT_CLEAR_DATA,
  GET_APPOINTMENT_ERROR,
  APPOINTMENTACTION_PATCH,
  APPOINTMENTACTION_PATCH_CLEAR_DATA,
  APPOINTMENTACTION_PATCH_ERROR,
  APPOINTMENTACTION_PATCH_SUCCESS,
  GET_APPOINTMENTACTION,
  GET_APPOINTMENTACTION_CLEAR_DATA,
  GET_APPOINTMENTACTION_ERROR,
  GET_APPOINTMENTACTION_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorGetAppointment: null,
  responseGetAppointment: null,
  loadingGetAppointment: false,
  errorGetAppointmentAction: null,
  responseGetAppointmentAction: null,
  loadingGetAppointmentAction: false,
  errorAppointmentActionPatch: null,
  responseAppointmentActionPatch: null,
  loadingAppointmentActionPatch: false,
};

const Appointment = (state = initialState, action) => {
  switch (action.type) {
    case GET_APPOINTMENT:
      state = {
        ...state,
        loadingGetAppointment: true,
        errorGetAppointment: null,
        responseGetAppointment: null,
      };
      break;
    case GET_APPOINTMENT_SUCCESS:
      state = {
        ...state,
        errorGetAppointment: null,
        loadingGetAppointment: false,
        responseGetAppointment: action.payload,
      };
      break;
    case GET_APPOINTMENT_ERROR:
      state = {
        ...state,
        errorGetAppointment: action.payload,
        loadingGetAppointment: false,
        responseGetAppointment: null,
      };
      break;
    case GET_APPOINTMENT_CLEAR_DATA:
      state = {
        ...state,
        errorGetAppointment: null,
        loadingGetAppointment: null,
        responseGetAppointment: false,
      };
      break;
    case GET_APPOINTMENTACTION:
      state = {
        ...state,
        loadingGetAppointmentAction: true,
        errorGetAppointmentAction: null,
        responseGetAppointmentAction: null,
      };
      break;
    case GET_APPOINTMENTACTION_SUCCESS:
      state = {
        ...state,
        errorGetAppointmentAction: null,
        loadingGetAppointmentAction: false,
        responseGetAppointmentAction: action.payload,
      };
      break;
    case GET_APPOINTMENTACTION_ERROR:
      state = {
        ...state,
        errorGetAppointmentAction: action.payload,
        loadingGetAppointmentAction: false,
        responseGetAppointmentAction: null,
      };
      break;
    case GET_APPOINTMENTACTION_CLEAR_DATA:
      state = {
        ...state,
        errorGetAppointmentAction: null,
        loadingGetAppointmentAction: null,
        responseGetAppointmentAction: false,
      };
      break;
    case APPOINTMENTACTION_PATCH:
      state = {
        ...state,
        loadingAppointmentActionPatch: true,
        errorAppointmentActionPatch: null,
        responseAppointmentActionPatch: null,
      };
      break;
    case APPOINTMENTACTION_PATCH_SUCCESS:
      state = {
        ...state,
        errorAppointmentActionPatch: null,
        loadingAppointmentActionPatch: false,
        responseAppointmentActionPatch: action.payload,
      };
      break;
    case APPOINTMENTACTION_PATCH_ERROR:
      state = {
        ...state,
        errorAppointmentActionPatch: action.payload,
        loadingAppointmentActionPatch: false,
        responseAppointmentActionPatch: null,
      };
      break;
    case APPOINTMENTACTION_PATCH_CLEAR_DATA:
      state = {
        ...state,
        errorAppointmentActionPatch: null,
        loadingAppointmentActionPatch: null,
        responseAppointmentActionPatch: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default Appointment;
